// src/App.jsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import your components from the correct path (assuming src/pages/)
import LandingPage from './pages/LandingPage.jsx';
import Login from './pages/Login.jsx';
import Home from './pages/Home.jsx';             // The Dashboard
import Portfolio from './pages/Portfolio.jsx';   // The Portfolio Manager
import BrowseStocks from './pages/BrowseStocks.jsx'; // The Stock Browser
import TerminalUI from './pages/TerminalUI.jsx'; // The new UI
import './App.css';


function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route: Landing Page */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />

        {/* Authenticated Routes */}
        <Route path="/home" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/browse-stocks" element={<BrowseStocks />} />

        {/* New Terminal UI Preview */}
        <Route path="/terminal" element={<TerminalUI />} />

        {/* You can add a 404/Not Found route here if desired */}
        {/* <Route path="*" element={<h1>404 Not Found</h1>} /> */}
      </Routes>
    </Router>
  );
}

export default App;